import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ThemeContext from "../../context/ThemeContext";
import moon from "../../assets/images/moon.png";
import sun from "../../assets/images/sun.png";
import "./navbar.css";
import { useNavigate } from "react-router";
import { wait } from "../../utils/genericUtils";
import ToggleSwitch from "../ui/toggle-switch/toggle-switch";
import { LogEvent } from "../../utils/EventLogging";

function Navbar(props) {
  const { theme, setTheme } = useContext(ThemeContext);
  const [navOpen, setNavOpen] = useState(false);

  const router = useNavigate();

  //once per load
  useEffect(() => {
    if (navOpen) {
      document.querySelector("#nav-shelf").style.maxHeight = "500px";
      document.querySelector("#nav-shelf").style.paddingTop = "20px";
      document.querySelector("#nav-shelf").style.paddingBottom = "20px";
    } else {
      document.querySelector("#nav-shelf").style.maxHeight = "0px";
      document.querySelector("#nav-shelf").style.paddingTop = "0px";
      document.querySelector("#nav-shelf").style.paddingBottom = "0px";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navOpen]);

  function toggleTheme() {
    if (theme === "light") {
      LogEvent("setTheme:dark");
      setTheme("dark");
    } else {
      LogEvent("setTheme:dark");
      setTheme("light");
    }
  }

  function toggleNav() {
    let toggle = document.querySelector("#nav-toggle");
    toggle.classList.toggle("open");
    setNavOpen(!navOpen);
    LogEvent("toggleNav");
  }

  function smoothScroll(target) {
    document.querySelector(target).scrollIntoView({
      behavior: "smooth",
      block: "start", // Scroll to the start of the target element
      inline: "start", // Scroll to the nearest edge of the target element
      scrollMargin: "-100px", // Add padding to the scroll
    });
  }

  function getCurrentPage() {
    // Get the current URL
    const url = window.location.href;

    // Extract the pathname from the URL
    const pathname = new URL(url).pathname;

    // Extract the current page from the pathname
    const currentPage = pathname.split("/").pop();

    return currentPage;
  }

  function setAllInactive() {
    document.querySelectorAll("a.active").forEach((link) => {
      link.classList.remove("active");
    });
  }

  function setActive(evt, id) {
    setAllInactive();
    if (!id) {
      let el = evt.target;
      el.classList.add("active");
    } else {
      let el = document.querySelector(id);
      el.classList.add("active");
    }
  }

  async function Home(evt) {
    toggleNav();
    let currentPage = getCurrentPage();
    setActive(evt);
    if (currentPage === "") {
      smoothScroll("#header");
    } else {
      router("/");
      await wait(500);
      smoothScroll("#header");
      setActive(null, "#header-link");
    }
  }

  async function AboutMe(evt) {
    toggleNav();
    let currentPage = getCurrentPage();
    setActive(evt);
    if (currentPage === "") {
      smoothScroll("#about");
    } else {
      router("/");
      await wait(500);
      smoothScroll("#about");
      setActive(null, "#about-me-link");
    }
  }

  async function Experience(evt) {
    toggleNav();
    let currentPage = getCurrentPage();
    setActive(evt);
    if (currentPage === "") {
      smoothScroll("#resume");
    } else {
      router("/");
      await wait(500);
      smoothScroll("#resume");
      setActive(null, "#experience-link");
    }
  }

  async function Projects(evt) {
    toggleNav();
    let currentPage = getCurrentPage();
    setActive(evt);
    if (currentPage === "") {
      smoothScroll("#projects");
    } else {
      router("/");
      await wait(500);
      smoothScroll("#projects");
      setActive(null, "#projects-link");
    }
  }

  return (
    <nav id="nav" className="navbar">
      <section className="nav-container">
        <section className="nav-left">
          {/* Logo removed per request */}
        </section>

        <section className="links-section">
          {/* Home */}
          <a
            id="header-link"
            className={getCurrentPage() === "" ? "nav-link active" : "nav-link"}
            onClick={(e) => {
              Home(e);
            }}
          >
            Home
          </a>
          {/* About Me */}
          <a
            id="about-me-link"
            className="nav-link"
            onClick={(e) => {
              AboutMe(e);
            }}
          >
            About Me
          </a>
          {/* Experience */}
          <a
            className="nav-link"
            id="experience-link"
            onClick={(e) => {
              Experience(e);
            }}
          >
            Experience
          </a>
          {/* Projects */}
          <a
            className="nav-link"
            id="projects-link"
            onClick={(e) => {
              Projects(e);
            }}
          >
            Projects
          </a>
          <div className={`theme-button ${theme === "light" ? "light" : ""}`} onClick={toggleTheme}>
            {theme === "light" ? (
              <>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#1e293b' }}></div>
                <span>Dark Mode</span>
              </>
            ) : (
              <>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ffffff' }}></div>
                <span>Light Mode</span>
              </>
            )}
          </div>
        </section>

        <section className="responsive-links">
          <button id="nav-toggle" className="nav-toggle" onClick={toggleNav}>
            <div className="nav-toggle-brgr"></div>
          </button>
        </section>
      </section>

      <section id="nav-shelf" className="nav-shelf" style={{ backgroundColor: "var(--backgroundSecondary)" }}>
        {/* Home */}
        <a
          id="header-link-mobile"
          className="nav-link active"
          onClick={(e) => {
            Home(e);
          }}
        >
          Home
        </a>
        {/* About Me */}
        <a
          id="about-me-link-mobile"
          className="nav-link"
          onClick={(e) => {
            AboutMe(e);
          }}
        >
          About Me
        </a>
        {/* Experience */}
        <a
          id="experience-link-mobile"
          className="nav-link"
          onClick={(e) => {
            Experience(e);
          }}
        >
          Experience
        </a>
        {/* Projects */}
        <a
          id="projects-link-mobile"
          className="nav-link"
          onClick={(e) => {
            Projects(e);
          }}
        >
          Projects
        </a>
        <div className="theme-toggle-switch-container">
          <div className={`theme-button ${theme === "light" ? "light" : ""}`} onClick={toggleTheme}>
            {theme === "light" ? (
              <>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#1e293b' }}></div>
                <span>Dark Mode</span>
              </>
            ) : (
              <>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ffffff' }}></div>
                <span>Light Mode</span>
              </>
            )}
          </div>
        </div>
      </section>
    </nav>
  );
}

export default Navbar;
